import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import useClickOutsideListener from '@Utils/UseClickOutsideListener'

interface ActionDropdownProps {
  readonly showDropdown: boolean
  readonly dropdownList: JSX.Element
  readonly classNamesForListContainer: string
  readonly classNameForClickOutsideListener: string
  readonly classNameOfScrollContainer?: string
  readonly idOfDropdownElement: string
  readonly idOfPortalContainer: string
  readonly dropdownOffsetX: number
  readonly dropdownOffsetY: number
  readonly dropdownWidth: number
  setShowDropdown(newShowDropdown: boolean): void
}

const ActionDropdown: React.FC<ActionDropdownProps> = props => {
  const {
    showDropdown,
    dropdownList,
    dropdownWidth,
    dropdownOffsetX,
    dropdownOffsetY,
    idOfPortalContainer,
    idOfDropdownElement,
    classNamesForListContainer,
    classNameOfScrollContainer,
    classNameForClickOutsideListener,
  } = props

  const moreElement = document.getElementById(idOfDropdownElement)
  const moreBounds = moreElement!.getBoundingClientRect()
  const dropdownX = moreBounds.left + window.scrollX - dropdownWidth + dropdownOffsetX
  const dropdownY = moreBounds.top + window.scrollY + moreBounds.height + dropdownOffsetY
  const style = {
    top: `${dropdownY}px`,
    left: `${dropdownX}px`,
  }

  useEffect(() => {
    if (classNameOfScrollContainer) {
      const scrollContainer = document.querySelector(`.${classNameOfScrollContainer}`)

      if (!scrollContainer) { return }

      const handleScroll = () => {
        props.setShowDropdown(false)
      }

      scrollContainer.addEventListener('scroll', handleScroll)

      return () => { scrollContainer.removeEventListener('scroll', handleScroll)}
    }
  }, [])

  useClickOutsideListener(classNameForClickOutsideListener, props.setShowDropdown, showDropdown)

  return ReactDOM.createPortal(
    (
      <div
        className={`${classNamesForListContainer} ${classNameForClickOutsideListener}`}
        style={style}
      >
        {dropdownList}
      </div>
    ),
    document.getElementById(idOfPortalContainer)!
  )
}

export default ActionDropdown
